<template>
  <div>
    <layout-panel>
      <span slot="header">冲销审批</span>
      <el-form
        ref="form"
        :model="model"
        size="medium"
        label-width="120px"
      >
        <el-row :gutter="20" style="margin-left: 0px" class="invoice-row">
          <el-col :span="1" class="col-center">序号</el-col>
          <el-tooltip
            class="item"
            effect="dark"
            content="没有项目编号则留空"
            placement="top"
          >
            <el-col :span="2" class="col-center">项目编号</el-col>
          </el-tooltip>
          <el-col :span="3" class="col-center">费用承担部门</el-col>
          <el-col :span="3" class="col-center">一级科目</el-col>
          <el-col :span="3" class="col-center">二级科目</el-col>
          <el-col :span="2" class="col-center">发票类型</el-col>
          <el-col :span="2" class="col-center">税率%</el-col>
          <el-col :span="2" class="col-center">含税冲销金额</el-col>
          <el-col :span="2" class="col-center">发票张数</el-col>
          <el-col :span="2" class="col-center">摘要</el-col>
          <el-col :span="1" class="col-center">&nbsp;</el-col>
          <el-col :span="1" class="col-center">&nbsp;</el-col>
        </el-row>
        <br />

        <el-row
          :gutter="20"
          v-for="(detailItem, itemIndex) in model.write_off_detail"
          :key="itemIndex"
          class="invoice-row"
          style="margin-top:5px"
        >
          <!--序号-->
          <el-col style="text-align: center" :span="1">
            {{ itemIndex + 1 }}
          </el-col>

          <!-- 项目编号 -->
          <el-col key="project_id" :span="2">
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                detailItem.project_id > 0
                  ? detailItem.project_name + '/' + detailItem.project_number
                  : ''
              "
              placement="top"
            >
              <span style="word-break: break-all;">{{detailItem.project_id > 0 ? (projectNames[detailItem.project_id] + '/' + detailItem.project_number) : '无'}}</span>
            </el-tooltip>
          </el-col>
          <!-- 费用承担部门 -->
          <el-col key="department_id" :span="3">
            <span>{{detailItem.department_name}}</span>
          </el-col>

          <!--一级科目-->
          <el-col :span="3">
            <!-- <span>{{originFirstSubjects[detailItem.first_subject]}}</span> -->
            <el-select
              v-model="detailItem.first_subject"
              @change="val => writeOffFirstSubjectChange(val, itemIndex)"
            >
              <el-option
                v-for="(label, value) in originFirstSubjects"
                :key="value"
                :label="label"
                :value="Number(value)"
              >
              </el-option>
            </el-select>
          </el-col>
          <!--二级科目-->
          <el-col :span="3">
            <!-- <span>{{originSecondSubjects[detailItem.second_subject]}}</span> -->
            <el-select v-model="detailItem.second_subject">
              <el-option
                v-for="(label, value) in writeOffSecondSubjects[itemIndex]"
                :key="value"
                :label="label"
                :value="Number(value)"
              >
              </el-option>
            </el-select>
          </el-col>
          <!--发票类型-->
          <el-col :span="2">
            <el-select
              v-model="detailItem.invoice_type"
              @change="val => writeOffInvoiceTypeChange(val, itemIndex)"
            >
              <el-option
                v-for="(label, value) in invoiceType"
                :key="value"
                :label="label"
                :value="Number(value)"
              >
              </el-option>
            </el-select>
            <!-- <span>{{invoiceType[detailItem.invoice_type]}}</span> -->
          </el-col>
          <!--税率-->
          <el-col :span="2" style="text-align:center;overflow: auto;">
            <el-input
              :disabled="detailItem.invoice_type === 1"
              placeholder="请输入"
              v-model="detailItem.tax_rate"
            ></el-input>
            <!-- <span>{{ detailItem.invoice_type === 1 ? '-' : (taxRateType[detailItem.tax_rate] || (detailItem.tax_rate + '%')) }}</span> -->
          </el-col>
          <!--含税金额-->
          <el-col :span="2" style="text-align:center;overflow: auto;">
              <span>￥{{detailItem.amount | seperateThousandsToFixed(2)}}</span>
          </el-col>
          <!--发票张数-->
          <el-col :span="2">
              <span>{{detailItem.invoice_count}}</span>
          </el-col>
          <!--摘要-->
          <el-col :span="2">
            <span style="word-break: break-all;">{{detailItem.desc}}</span>
          </el-col>
        </el-row>
        <br />
        <el-row class="invoice-row" :gutter="20">
          <el-col :span="16">
            <p style="padding: 0; margin:0; text-align: right;">
              冲销金额合计：
            </p>
          </el-col>
          <el-col :span="2">
            ￥{{ totalWriteOffAmount | seperateThousandsToFixed(2) }}
          </el-col>
          <el-col :span="2">
            {{ totalWriteOffInvoiceCount }}
          </el-col>
        </el-row>

        <el-form-item label="核销说明："
                      prop="desc">
            <span>{{model.desc}}</span>
        </el-form-item>
        <el-form-item label="附件："
                      prop="attached_file">
          <div class="view-navbar">
            <ul class="clear-both">
              <li v-for="(item, index) in model.attached_file" :key="index">
                <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                  <img v-if="item.type === 'pic' && item.pic_url" style="width: 100px; height: 100px" :src="item.pic_url | ossHost" @click="onViewImage">
                  <i v-else
                      class="sj-icon-pdf"
                      style=" font-size:100px; margin-top: 50px"
                      @click="onGetPdfFile(item, index)"></i>
                </el-tooltip>
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="冲销日志："
                      prop="log">
            <span style="white-space:pre-wrap;">{{writeOffLogFrom(model.log)}}</span>
        </el-form-item>
        <el-form-item label="冲销日期:" prop="write_off_at" v-if="model.status === 7">
          <el-date-picker
            v-model="model.write_off_at"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="dateTimePickerRangeOptions"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="驳回原因：" prop="write_off_at">
          <el-input v-model="model.reason" placeholder="驳回时填写，通过无需填写"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit(true)">审批通过</el-button>
          <el-button type="danger" @click="onSubmit(false)">审批驳回</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>


<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import AttachedFiledUpload from './PaymentAttachedFileUpload.vue'
const WRITEOFFDETIALITEM = {
  project_id: null,
  project_number: null,
  department_id: null,
  department_name: null,
  first_subject: null,
  second_subject: null,
  invoice_type: null,
  tax_rate: null,
  amount: null,
  invoice_count: null,
  desc: null,
  canSelectDepartment: true,
}

export default {
  components: {
    AttachedFiledUpload
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    projectNames: {
      type: Object,
      required: true,
      default: () => {},
    },
    originFirstSubjects: {
      type: Object,
      required: true,
      default: () => {},
    },
    originSecondSubjects: {
      type: Object,
      required: true,
      default: () => {},
    },
    writeOffAssociatedRelationships: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  watch: {
    data: {
      immediate: true,
      handler (val) {
        this.setupModel(val.write_off_lists.find(item => [6, 7].includes(item.status)))
      }
    }
  },
  computed: {
    ...Vuex.mapState({
      invoiceType: state => state.paymentManager.invoiceType,
      taxRateType: state => state.paymentManager.taxRateType,
    }),
    // 冲销金额合计
    totalWriteOffAmount () {
      return this.model.write_off_detail.reduce((total, item) => {
        return total + Number(item.amount)
      }, 0)
    },

    // 发票数量合计
    totalWriteOffInvoiceCount () {
      return this.model.write_off_detail.reduce((total, item) => {
        return total + Number(item.invoice_count)
      }, 0)
    },
  },
  data () {
    return {
      model: {
        attached_file: [],
        amount: null,
        write_off_at: null,
        write_off_detail: [_.cloneDeep(WRITEOFFDETIALITEM)],
      },
      writeOffSecondSubjects: [{}],
      dateTimePickerRangeOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  methods: {
    ...request.map([
      'getProjectTable',
      'getProjectDetail',
    ]),

    setupModel (data) {
      this.model = filter.copyJson(data)
      data.write_off_detail.forEach((item, index) => {
        if (this.model.write_off_detail.length === index) {
          this.addDetailItem()
        }
        this.writeOffFirstSubjectChange(item.first_subject, index)
        const writeOffDetail = this.model.write_off_detail[index]
        writeOffDetail.project_id = item.project_id
        writeOffDetail.project_name = item.project_id > 0 ? this.projectNames[item.project_id] : ''
        writeOffDetail.project_number = item.project_number
        writeOffDetail.department_id = item.department_id
        writeOffDetail.department_name = item.department_name
        writeOffDetail.first_subject = item.first_subject
        writeOffDetail.second_subject = item.second_subject
        writeOffDetail.invoice_type = item.invoice_type
        writeOffDetail.invoice_count = item.invoice_count
        writeOffDetail.tax_rate = item.tax_rate
        writeOffDetail.amount = item.amount
        writeOffDetail.desc = item.desc
        if (item.project_number && Number(item.project_id)) {
          if (item.project_number[0] === 'H') {
            writeOffDetail.canSelectDepartment = true
          } else {
            writeOffDetail.canSelectDepartment = false
          }
        } else {
          writeOffDetail.canSelectDepartment = true
        }
        if (parseInt(item.project_id) === 0) {
          writeOffDetail.project_id = null
        }
        if (parseInt(item.department_id) === 0) {
          writeOffDetail.department_id = null
        }
      })
    },
    changeProject (val, index) {
      this.model.write_off_detail[index].project_id = val.id
      this.model.write_off_detail[index].project_name = val.name
      this.model.write_off_detail[index].project_number = val.number

      let canSelectDepartment = true
      if (val === '') {
        canSelectDepartment = true
      } else {
        if (val.number.length > 0) {
          const projectNumberFirstChart = val.number[0]
          if (projectNumberFirstChart === 'H') { // 项目编号首字母为H
            canSelectDepartment = true
          } else { // 禁用 费用承担部门
            this.model.write_off_detail[index].department_id = null
            canSelectDepartment = false
          }
        }
      }
      this.model.write_off_detail[index].canSelectDepartment = canSelectDepartment
    },
    addDetailItem () {
      this.model.write_off_detail.push(_.cloneDeep(WRITEOFFDETIALITEM))
      this.writeOffSecondSubjects.push({})
    },
    removeDetailItem (index) {
      this.model.write_off_detail.splice(index, 1)
    },
    writeOffFirstSubjectChange (val, index) {
      this.model.write_off_detail[index].second_subject = null
      const secondSubjects = {}
      const secondSubjectIds = this.writeOffAssociatedRelationships[val]
      for (const index in secondSubjectIds) {
        const id = secondSubjectIds[index]
        secondSubjects[id] = this.originSecondSubjects[id]
      }
      this.writeOffSecondSubjects[index] = secondSubjects
    },
    writeOffInvoiceTypeChange (val, index) {
      if (val === 1) {
        this.model.write_off_detail[index].tax_rate = 0
      } else {
        this.model.write_off_detail[index].tax_rate = null
      }
    },
    checkPaymentDetail () {
      if (!this.model.write_off_at) {
        this.$message.error('请选择冲销日期')
        return false
      }
      let list = this.model.write_off_detail
      let rule = {
        first_subject: '一级科目',
        second_subject: '二级科目',
        amount: '含税金额',
        desc: '摘要',
      }
      for (let i = 0; i < list.length; i++) {
        for (const ruleKey in rule) {
          if (!list[i][ruleKey]) {
            this.$message.error(rule[ruleKey] + '不能为空！')
            return false
          }
        }
        if (list[i].tax_rate > 100 || list[i].tax_rate < 0) {
          this.$message.error('请输入正确的税率,范围0 ~ 100！')
          return false
        }
        let projectNumberFirstChart = ''
        if (list[i].project_number && typeof list[i].project_number === 'string') {
          projectNumberFirstChart = list[i].project_number.substr(0, 1)
        }
        if (projectNumberFirstChart === 'H' || !list[i].project_number) { // 项目编号首字母为H或者无编号
          if (!list[i].department_id) {
            this.$message.error('请选择费用承担部门！')
            return false
          }
        }
        if (!list[i].invoice_count && !this.isBatch && !this.isPrepaymentType) {
          this.$message.error('请填写发票张数')
          return false
        }
      }
      return true
    },
    onSubmit (pass) {
      if (pass) {
        this.pass(this.model.id)
      } else {
        this.reject(this.model.id)
      }
    },
    pass (id) {
      let api = 'finAccountantPassPaymentWriteOffData'
      const params = {id, write_off_detail: this.model.write_off_detail}
      if (this.model.status === 7) {
        api = 'finManagerPassPaymentWriteOffData'
        params.write_off_at = this.model.write_off_at
      }
      request.common(api, params).then((res) => {
        this.$alert('审核成功', '提示', {type: 'success'}).then(() => {
          this.$router.back()
        })
      })
    },
    reject (id) {
      if (!this.model.reason) {
        this.$message.error('请输入驳回原因')
        return
      }
      request.common('rejectPaymentWriteOffData', {id, reason: this.model.reason}).then((res) => {
        this.$alert('审核成功', '提示', {type: 'success'}).then(() => {
          this.$router.back()
        })
      })
    },
    writeOffLogFrom (logs) {
      return logs ? logs.reduce((total, item) => {
        return total + `${item.created_at} ${item.admin_name}/${item.admin_real_name || '-'} ${item.desc}\n`
      }, '') : ''
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
    // 费用承担部门
    searchDepartments (name) {
      return request.common('getFinCenterDepartmentTableList', {...name, is_disabled: 0})
    },
    getDepartmentDetail (id) {
      return request.common('getFinCenterDepartmentDetail', id)
    },

  },
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.col-center {
  text-align:center
}
.invoice-row .el-col {
  line-height: 30px;
  text-align: center;
}

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;

  ul {
    transform: translateX(0px);
    transition: all 0.3s;
    box-sizing: content-box;
    // height: 100px;
    overflow: hidden;
    padding: 1px 0;

    li {
      float: left;
      list-style: none;
      width: 100px;
      height: 100px;
      margin-right: 5px;
      cursor: pointer;
      font-size: 0;
      line-height: 0;
      overflow: hidden;
      transition: opacity 0.15s;
    }
  }
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/payment-approval/components/PaymentWriteOffReview.vue